import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import { createApp }  from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";

import App from "./App";
import appInfo from "./app-info";
import ActionEnginePlugin from './plugins/actionEngine.js';

import xior from 'xior';

themes.initialized(() => {
	const app = createApp(App);
	// Initialize our API link. This link is used for all REST calls except authentication, which is defined in auth.js.
	const $http = xior.create({
		baseURL: (appInfo.baseURL.endsWith('/') ? appInfo.baseURL.slice(0, -1) : appInfo.baseURL),
		headers: { 'Accept': 'application/json' },
	});
	app.provide('$http', $http);
	
	// Install and initialize the action engine plugin, used to handle user-defined action execution and persistence.
	try {
		app.use(ActionEnginePlugin, {
			nodes: [
				{ id: 1, type: 'click' },
				{ id: 2, type: 'show_dialog' },
				{ id: 9, type: 'exit' },
			],
			connections: [
				{ sourceId: 1, targetId: 2, socketFrom: 'clicked', socketTo: 'show' },
				{ sourceId: 2, targetId: 9, socketFrom: 'ok', socketTo: 'finished' },
			],
			debug: true,
		});
	} catch (exception) {
		console.error(exception);
		console.error('Error initializing action engine plugin. Action engine will be disabled.');
	}
	
	app.use(router);
	app.config.globalProperties.$appInfo = appInfo;

	app.mount('#app');
});
